export interface InvoiceItemDto {
  name: Nullable<string>;
  netWeight: Nullable<number>;
  quantity: Nullable<number>;
  price: Nullable<number>;
  cost: Nullable<number>;
  size: Nullable<string>;
  height: Nullable<string>;
  packageType: Nullable<string>;
  ruName: Nullable<string>;
}

export interface InvoiceStatisticsItem {
  name: Nullable<string>;
  ruName: Nullable<string>;
  packageQuantity: Nullable<number>;
  quantity: Nullable<number>;
  tnVed: Nullable<string>;
  grossWeight: Nullable<number>;
  netWeight: Nullable<number>;
  cost: Nullable<number>;
}

export interface InvoiceDto {
  id: Nullable<number>;
  number: Nullable<string>;
  date: Nullable<string>;
  buyer: Nullable<string>;
  buyerId: Nullable<number>;
  seller: Nullable<string>;
  sellerId: Nullable<number>;
  items: InvoiceItemDto[];
  statisticsItems: InvoiceStatisticsItem[];
  cost: Nullable<number>;
  currencyLetter: Nullable<string>;
  previewId: Nullable<number>;
  orderId: Nullable<number>;
  groupId: Nullable<number>;
}

export enum ResolutionStrategy {
  FULL = 'FULL',
  ACCOUNTING = 'ACCOUNTING',
}
